import { useEffect } from 'react'

import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { addResultToLink } from '../helpers'
import type { Props as PwgProps } from './form'
import type { Props as PwgRecordsProps } from './records'
import type { Props as PwgResultProps } from './result'

const PWGToolResultPageComponent = dynamic<PwgResultProps>(
  () => import('./result'),
)

const PWGToolPageComponent = dynamic<PwgProps>(() => import('./form'))

const PWGRecordsPageComponent = dynamic<PwgRecordsProps>(
  () => import('./records'),
)

export type InputError = {
  age: string
  weight: string
  height: string
}

export type ToolPageType = 'form' | 'result'

export type Props = PwgProps | PwgResultProps | PwgRecordsProps

export const PWGToolPage = (props: Props) => {
  const { type = 'form' } = props
  const router = useRouter()
  useEffect(() => {
    if (type === 'result' || type === 'records') {
      if (!router.asPath.includes('?result=1')) {
        const newPath = addResultToLink(router.asPath)
        router.push(newPath, newPath, { shallow: true })
      }
    }
  }, [type])

  if (type === 'result') {
    return <PWGToolResultPageComponent {...(props as PwgResultProps)} />
  } else if (type === 'form') {
    return <PWGToolPageComponent {...(props as PwgProps)} />
  } else {
    return <PWGRecordsPageComponent {...(props as PwgRecordsProps)} />
  }
}
